import React from 'react';
import clsx from 'clsx';

interface OwnProps {
  isActive: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}

const MenuTag = (props: OwnProps) => {
  const { isActive, onClick = () => {} } = props;

  return (
    <div
      className={clsx(
        'rounded-full border border-neutral-700 py-1 px-3 w-fit h-fit cursor-pointer',
        isActive ? 'bg-neutral-700' : 'bg-neutral-100',
      )}
      onClick={onClick}
    >
      {props.children}
    </div>
  );
};

export default MenuTag;
